import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableDocumentsToAdd } from "../../../../../actions/accidentDashboard";
import { StyledFlex } from "../../../../styled/flex";
import CardTitle from "../cardTitle";
import AddDocumentationCards from "./addDocumentationCards";

const AddDocumentation = () => {
  const dispatch = useDispatch();

  const accident = useSelector((state) => state.accidentDashboard.accident);
  const documentation = useSelector(
    (state) => state.accidentDashboard.availableDocumentsToAdd,
  );

  useEffect(() => {
    dispatch(
      getAvailableDocumentsToAdd(
        accident.idSiniestro,
        accident.mlCloudCoreArtId,
      ),
    );
  }, []);

  return (
    <>
      <StyledFlex.ColumnContainer>
        <CardTitle title="AGREGAR DOCUMENTACIÓN" color="primary" />
        <AddDocumentationCards
          data={documentation.data}
          loading={documentation.isFetching}
        />
      </StyledFlex.ColumnContainer>
    </>
  );
};

export default AddDocumentation;
